'use strict';
import isDate from 'lodash/isDate';
import isNumber from 'lodash/isNumber';
import moment from 'moment/moment';
import {getFilterDataFromListState} from '../../_libs/redux-observable-list';
import {FilterModalOptions} from '../../core-utilities/filters/FilterModalOptions';
import {groupByDate} from '../../components/lists/DateHeader';
import {defaultFilterOptions} from '../../priorities/redux/prioritiesListConfig';
import {getUserTodoList} from '../reducers/state';
import {USER_TODO_LIST_PREFIX} from './state';
import {applySortOptions, buildList, defaultSortOptions} from './todoMessagesConfig';
import {applyDefaultReduxListComponentOptions} from '../../core-utilities/redux/ReduxListContainer';


/** @type {TodoMessageReduxList} */
export const userTodoListReduxList = buildList({
  prefix: USER_TODO_LIST_PREFIX,
  getState: getUserTodoList,
}, {
  cacheName: 'userTodoList',
});

export function getUserTodoFilterData(listState) {
  return getFilterDataFromListState(userTodoListReduxList.options, listState);
}

export const filterModalOptions = new FilterModalOptions({
  filterOptions: defaultFilterOptions,
  sortOptions: defaultSortOptions,
});

export const componentOptions = applyDefaultReduxListComponentOptions(userTodoListReduxList.options, {
  applySortOptions,
  filterModalOptions,
  listTransform: groupByDate({
    filter: todoMsg => todoMsg.isSupported !== false,
    dateFormatter,
    dateGetter: todoMsg => {
      const date = todoMsg.date;
      if (!date) {
        return null;
      } else if (isNumber(date)) {
        return dateFormatter(date);
      } else if (isDate(date)) {
        return dateFormatter(date.getTime());
      } else {
        return null;
      }
    },
  }),
});

function dateFormatter(date) {
  const d = new Date(date);
  return moment([d.getFullYear(), d.getMonth()]).valueOf();
}



// WEBPACK FOOTER //
// ./src/js/todo-messages/redux/userTodoList.js